import { clear, del, entries, set } from 'idb-keyval';
import { ILog, downloadText, AlertInterface, LogInterface, IMappingDetail, GetContextMenuItemsParams, GridApi, MenuItem } from '@samc/centricity-core';
import { AjaxHelper } from '@samc/common';
import { IEntityData } from '@samc/taskmanagement-ui';
import { ILSDefaults, LSDefaultKey, INotificationError, INotificationErrorResponse } from './Interfaces';
import PapaParse from 'papaparse';
import XLSX from '@samc/sheetjs-style';
import { format } from 'date-fns';
import { MenuItemDef } from 'ag-grid-community';
import LoanDetailsHandler from './LoanDetailsHandler';

// this is curtesy: https://stackoverflow.com/a/25490531 and efficiently parses a single cookie value from the long string of all cookies that document provides
export function getCookieValue(name: string) {
  let b = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}
//Terry will remove this
export function uriJoin(...items: string[]) {
  const formatted = items
    .filter(x => x !== undefined && x !== null)
    .map(x => x.startsWith('/') ? x.substr(1) : x)
    .map(x => x.endsWith('/') ? x.substr(0, x.length - 1) : x)
    .map(x => x.trim())
    .filter(x => x.length > 0);
  return formatted.length === 1 ? `/${formatted[0]}` : formatted.join('/');
}

// Generate a guid
// Found at: https://stackoverflow.com/questions/105034/how-to-create-guid-uuid
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// Export function found at: https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
export function download(data: string | Blob | BufferSource, filename: string, mime: string) {
  var blobData = [data];
  var blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
  if (typeof (window.navigator as any).msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    (window.navigator as any).msSaveBlob(blob, filename);
  }
  else {
    var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
    var tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    // Fixes "webkit blob resource error 1"
    setTimeout(function () {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 200)
  }
}


//Terry has promised that he will move logging to common package or somewhere soon.

entries().then(logs => {
  //trim logs to limit on page load
  if (logs.length > 500) {
    logs = logs
      .filter(k => k[0].toString().startsWith('cLog'))    
      .sort((a, b) => { return Date.parse((b[1] as ILog).time) - Date.parse((a[1] as ILog).time); });
    for (let i = 499; i < logs.length; i++) {
      del(logs[i][0]).catch((err) => { console.error(err); });
    }
  }
});

export function logMessage(log: ILog) {
  const key = 'cLog_' + guid()
  log.time = new Date().toUTCString();
  log.windowId = window.$$windowId || 'unknown';
  set(key, log)
    .catch((err) => { console.error(err); });
}


export function exportLogs() {
  entries().then(logs => {
    logs = logs
      .filter(k => k[0].toString().startsWith('cLog_'))
      .map(l => l[1])
      .sort((a: ILog, b: ILog) => { return Date.parse(b.time) - Date.parse(a.time); });///inefficient but who cares / only happens when you click link
    downloadText(JSON.stringify(logs, null, 2), 'logs.json', 'application/json');
  });
}

export function clearLogs() {
  clear().then();
}

export function isNullOrEmpty(val: string | null) {
  return val === null || val.length === 0;
}

// either show an alert with error messages from response or log the error and show a generic error alert
export function handleErrorResponse(e: any, $alert: ReturnType<typeof AlertInterface>, $log: ReturnType<typeof LogInterface>, userErrorMsg: string | null = null) {
  if (e?.response?.status === 400) {
    $alert.error(userErrorMsg ?? 'The following errors occurred.', '', false, e);
  } else {
    $log.error(e);
    $alert.error(`An error occurred.`);
  }
}

// parses JSON from an element's dataset.json and returns it as an object of the given Type
export function parseDatasetJson<T>(ele: HTMLDivElement): T | null {
  if (ele?.dataset?.json === undefined) return null;

  var json = atob(ele.dataset.json);
  return JSON.parse(json);
}

/**
 * Programatically triggers a right-click event on ag-grid cells thus forcing the grid
 * to call our custom context menu handlers where we can access and store a reference to the L&S grid
 * @param gridWrapperId The ID of an ancestor element of the grid
 */
export function triggerLsGridRightClick(gridWrapperId: string, hideContextMenu: boolean = true) {

  const gridCell = document.getElementById(gridWrapperId)?.querySelector('.ag-cell');
  if (!gridCell) {
    $log.warn('Could not find a grid cell to trigger the context menu.', gridWrapperId);
    return;
  }

  const rightClick = gridCell.ownerDocument.createEvent('MouseEvents');
  rightClick.initMouseEvent('contextmenu', true, true, gridCell.ownerDocument.defaultView as any
    , 1, 0, 0, 0, 0, false, false, false, false, 2, null);

  gridCell.dispatchEvent(rightClick);

  if (hideContextMenu) {
    const agMenuElements = document.getElementsByClassName('ag-menu');
    if (agMenuElements[0]?.parentElement && (agMenuElements[0].parentElement.className.indexOf('ag-popup') ?? -1) > -1) {
      agMenuElements[0].parentElement.style.display = 'none';
    }
  }
}

export async function getLSDefaults(key: LSDefaultKey) {
  const helper = new AjaxHelper('/configApi/v1', null, null, null);
  return await helper.getData<ILSDefaults>(`ls-defaults/${encodeURIComponent(key)}`);
}

/**
* Helper method to return user friendly message from INotificationErrorResponse
*
* @param errordata The error response data
*/
export function handleErrorData(errorData: any): string {
  let message = '';
  if (errorData.errors?.length > 0) {
    const parsedErrors = errorData as INotificationErrorResponse;
    parsedErrors.errors.forEach((e: INotificationError) => {
      message += e.message + ' ';
    });
  } else {
    message = errorData;
  }
  return message;
}

/**
   * Calls AgGrid's autoSizeAllColumns for a given grid only if the columns have been minimized
   * This is a workaround for a bug in AgGrid that causes the columns to appear smashed together after redraws
   * 
   * @param gridColumnApi ColumnApi instance for the grid
   * @param force True if columns should be resized even if we haven't detected minimized columns
   */
export function autoSizeGridColumns(api: GridApi | null, force: boolean = false) {
  if (!api) return;

  if (!force) {
    const cols = api.getColumnDefs();
    if (!cols || cols.length < 2) return; // don't autosize if there's less than 2 columns

    // Use (api as any).getColumnApi to fix type error (GridApi does not have getColumnApi in typings)
    const columnApi = (api as any).getColumnApi?.();
    if (!columnApi) return;

    const displayedColumns = columnApi.getAllDisplayedColumns();
    if (!displayedColumns || displayedColumns.length < 2) return;

    const firstTwoColsWidth = displayedColumns[0].getActualWidth() + displayedColumns[1].getActualWidth();
    if (firstTwoColsWidth >= 25) return; // only autosize when first 2 cols have combined width < 25
  }

  const columnApi = (api as any).getColumnApi?.();
  if (columnApi) {
    setTimeout(() => columnApi.autoSizeAllColumns(), 1);
  }
}

export function exportGridDataAsExcel(params: GetContextMenuItemsParams, fileName : string) {
    let content = params.api.getDataAsCsv();
    if(!content)
        return;                
    var jSonObject = PapaParse.parse(content, {
        header: true
    });
    const ws = XLSX.utils.json_to_sheet(jSonObject.data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, fileName + ".xlsx");
}

export function isDetailUnmapped<T extends IMappingDetail>(detail: T) {
  return detail.internalFieldId === null || detail.internalFieldId === undefined || detail.internalFieldId === 0;
}

export function parseISOUTC(str: string): Date {
  return new Date(ensureISOUTC(str));
}

export function ensureISOUTC(str: string): string {
  if (!str.endsWith('Z'))
    str += 'Z';
  return str;
}

/**
 * Generates a form html element and summits it so that we can move to posted endpoints
 * 
 * @param url The current url we need to get sent too
 * @param data The data that should be sent along with this request
 */
export const gotoPost = (url: string, verificationToken: string | null, data: Record<string, unknown>) => {
  data["__RequestVerificationToken"] = verificationToken;

  const form = document.createElement('form');
  form.style.display = 'none';
  form.action = url;
  form.method = 'POST';
  form.innerHTML = Object.keys(data)
    .filter(x => data[x] !== undefined || data[x] !== null)
    .map(x => `<input type="hidden" name="${x}" value="${data[x]}" />`)
    .join('');

  document.body.appendChild(form);
  form.submit();
}

/**
 * Returns current datetime in the system time-zone.
 */
export const getCurrentDateTime = () => {
  return format(new Date(), 'yyyyMMddHHmmss');
};

/**
 * Filters package name by removing forbidden special characters
 * @param value The input package name value
 * @param updateCallback Function to call with the filtered value if it changed
 * @param showWarning Function to call to show warning message when characters are filtered
 * @returns The filtered package name
 */
export const filterPackageName = (
  value: string, 
  updateCallback?: (filteredValue: string) => void,
  showWarning?: () => void
): string => {
  const originalValue = value;
  
  // Remove forbidden special characters using the same regex as validation
  // eslint-disable-next-line no-useless-escape
  const forbiddenCharacters = /[/\\%$*\[\]{}?^+~@<>|]/g;
  const filteredValue = originalValue.replace(forbiddenCharacters, '');
  
  // Only update if the value actually changed (character was filtered out)
  if (filteredValue !== originalValue) {
    updateCallback?.(filteredValue);
    showWarning?.();
  }
  
  return filteredValue;
};

/**
 * Filters out export-related menu items from AG Grid context menu
 * This function removes CSV export, Excel export, and other export options from the default context menu
 * 
 * @param params The context menu parameters from AG Grid
 * @returns Filtered array of context menu items with export options removed
 */
export function getContextMenuItemsWithoutExports(params: GetContextMenuItemsParams): (string | MenuItemDef)[] {
  // Get default menu items and filter out export options
  const defaultItems: (string | MenuItemDef)[] = params.defaultItems || [];
  
  // Filter out export-related menu items from the default context menu items
  return defaultItems.filter((item) => {
    if (typeof item === 'string') {
      const exportItems = ['csvExport', 'excelExport', 'export'];
      return !exportItems.includes(item);
    } else if (item && typeof item === 'object') {

      const menuItem = item as MenuItemDef;
      const name = menuItem.name?.toLowerCase() || '';
      
      // Check if this is an export menu item
      if (name.includes('export')) {
        return false;
      }
      
      // Check subMenu if it has any export items and if so, filter them out
      if (menuItem.subMenu) {
        const filteredSubMenu = menuItem.subMenu.filter((subItem) => {
          if (typeof subItem === 'string') {
            const exportItems = ['csvExport', 'excelExport', 'export'];
            return !exportItems.includes(subItem);
          } else if (subItem && typeof subItem === 'object') {
            const subName = (subItem as MenuItemDef).name?.toLowerCase() || '';
            return !subName.includes('export');
          }

          return true;
        });
        
        // If subMenu becomes empty after filtering, exclude the parent item
        if (filteredSubMenu.length === 0) {
          return false;
        }
        
        // Update the subMenu with filtered items
        menuItem.subMenu = filteredSubMenu;
      }
    }

    return true;
  });
}

export function addViewLoanDetailsAction(loanIds: any[], actions: (MenuItemDef | 'separator')[],
                                         detailsHandler: LoanDetailsHandler | null,
                                         entitledToViewLoanDetails: boolean | undefined = undefined): void {
  if (loanIds.length === 1 && detailsHandler !== null) {
    const handler = detailsHandler;
    actions.push({
      name: 'View Loan Details',
      action: () => handler.selectItem(),
      disabled: !entitledToViewLoanDetails
    });
  }
}

export interface IPackageEntity extends IEntityData {
  type: string;
  status: string;
  externalId: string;
}

export function handleGetEntityName(entityMap: Map<number, IPackageEntity>, evt: CustomEvent<{ data?: number; returns: (value: string) => void }>): void {
  const entityId = evt.detail.data;
  if (entityId !== null && entityId !== undefined) {
    const entity = entityMap.get(entityId);
    if (entity !== null && entity !== undefined) {
      evt.detail.returns(entity.name);
    }
  }
}

export function handleEntityClick(entityMap: Map<number, IPackageEntity>, evt: CustomEvent<number>): void {
  const entityId = evt.detail;
  if (entityId === null || entityId === undefined) return;
  const entity = entityMap.get(entityId);
  if (entity === null || entity === undefined || entity.externalId === null || entity.externalId === undefined) return;
  if (entity.type === 'Sell') {
    window.location.href = `/TransactionManagement/Deals/${entity.externalId}?tab=transaction-workflow`;
  } else {
    window.location.href = `/TransactionManagement/${entity.externalId}?tab=transaction-workflow`;
  }
}

/**
 * Checks if a given date is a business day (Monday to Friday)
 * @param date The date to check
 * @returns True if the date is a business day, false otherwise
 */
export function isWeekDay(date: string | Date): boolean {
  if (date && typeof date === 'string')  {
    const dateObj = new Date(date);
    return dateObj.getDay() !== 0 && dateObj.getDay() !== 6; // 0 = Sunday, 6 = Saturday
  }
  else if (date && date instanceof Date) {
    return date.getDay() !== 0 && date.getDay() !== 6; // 0 = Sunday, 6 = Saturday
  }

  return false;
}
